module.exports = __webpack_public_path__ + "static/media/theme_item.3aea65d8.svg";